// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"138cc1fa","827":"f3227951"}[chunkId] + ".chunk.js";
};